import { PropsWithChildren, useEffect, useRef } from 'react';

import { defaultParameterizeRoute } from '@spotify-confidence/csr-recorder';
import { useConfidence } from '@spotify-confidence/react';
import {
  type SessionRecorder,
  initAppSessionRecorder,
  useAuth,
} from '@spotify/confidence-core-react';
import { setFlagEvaluationContext } from '@spotify/confidence-flag-evaluation-react';
import { useFlagEvaluationContext } from '@spotify/plugin-confidence-iam-react';

import { parameterizeRoute } from '../routeParameterizer';

export function FlagContext({ children }: PropsWithChildren) {
  const { user, isAuthenticated, isLoading, orgName } = useAuth();
  const evaluationContext = useFlagEvaluationContext();
  const confidence = useConfidence();
  const sessionRecorderRef = useRef<SessionRecorder>();

  useEffect(() => {
    if (isLoading) return;

    confidence.setContext(evaluationContext);
    setFlagEvaluationContext(evaluationContext);

    if (!sessionRecorderRef.current && user) {
      sessionRecorderRef.current = initAppSessionRecorder({
        clientSecret: 'NiAgIVmkjVSTNI5k8mpsgs3EeFqkacrA',
        context: confidence.getContext(),
        parameterizeRoute: route =>
          parameterizeRoute(defaultParameterizeRoute(route)),
      });
    }
  }, [confidence, evaluationContext, isLoading, user]);

  useEffect(() => {
    const recorder = sessionRecorderRef.current;
    if (!recorder) return;
    if (isAuthenticated) {
      recorder.tag('isAuthenticated', `${isAuthenticated}`);
    }
    if (orgName) {
      recorder.tag('org_name', orgName);
    }
  }, [user, isAuthenticated, orgName]);

  // TODO wrap children in a ConfidenceProvider.WithContext({...user}) provider
  return <>{children}</>;
}
